module.exports = __webpack_public_path__ + "img/banner02.00c2d53e.jpg";